<template>
  <b-card no-body>
    <b-card-body>
      <b-card bg-variant="light">
        <b-form @submit.prevent="load">
          <b-form-row>
            <lg-form-const-select label="Tipo de Alteração:" cols="6" sm="4" md="2" v-model="form.codTipoAlteracao"
              @change="load" :options="optionsFilterTipos" />
            <LgFinderPagePessoa v-model="form.responsavel" @onselect="load" :prefix="[title + ' > ']" id="finderPagePessoa" label="Responsável:">
            </LgFinderPagePessoa>
            <b-col class="text-right">
              <b-button id="localizarReavaliacao" class="mr-2 my-2" size="sm" style="height: 20px" pill
                variant="primary" @click="load()">
                <div class="btn-size-alinhamento">
                  <b-icon icon="search" />
                  <b-tooltip target="localizarReavaliacao" title="Localizar" triggers="hover"></b-tooltip>
                </div>
              </b-button>
              <b-button id="novoReavaliacao" class="mr-2 my-2" size="sm" style="height: 20px" pill
                @click="abrirModalEdit" variant="primary">
                <div class="btn-size-alinhamento">
                  <b-icon scale="1" icon="plus" />
                </div>
                <b-tooltip target="novoReavaliacao" title="Adicionar novo..." triggers="hover"></b-tooltip>
              </b-button>
            </b-col>
          </b-form-row>
        </b-form>
        <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records" :fields="this.tableFields"
          :hover="true" @row-dblclicked="reavaliacaoSelect" show-empty>
          <template #empty>
            <p>Nenhum registro encontrado</p>
          </template>
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template v-slot:cell(descricao)="{ item }">
            <span v-if="item.codTipoAlteracaoValorItemBemPermanente === 1">Depreciação</span>
            <span v-else-if="item.codTipoAlteracaoValorItemBemPermanente === 2">Valorização</span>
          </template>
          <template v-slot:cell(editar)="{ item }">
            <b-button :id="'editar-' + item.id" class="my-2" size="sm" pill variant="primary"
              @click="abrirModalEdit(item)">
              <b-icon icon="pencil-square" />
              <b-tooltip :target="'editar-' + item.id" title="Editar..." triggers="hover"></b-tooltip>
            </b-button>
          </template>
          <template v-slot:cell(situacao)="{ item }">
            <b-form-checkbox v-model="item.situacaoDepreciacaoValorizacaoItemBemPermanente" @change="alteraSituacao(item)" name="check-button" switch size="lg"
              :value="1" :unchecked-value="0" />
          </template>
        </b-table>
        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
          <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de {{
              totalPage }} - {{ total }} registros</b-col>
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
              <b-form-select size="sm" v-model="perPage" @change="() => this.load()" :options="perPageOptions">
              </b-form-select>
            </b-col>
          </b-col>
          <b-col cols="6">
            <div class="d-flex justify-content-end align-items-end">
              <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                :total-rows="total"></b-pagination>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-card-body>
    <ReavaliacaoForm v-if="showModalEdit" @close="cancelar" :ItemBemPermanente='ItemBemPermanente' :isModal="true" :id="id"
      :prefix="updatedPrefix" />
  </b-card>
</template>

<script>
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue"
import ResourceService from "@/core/api/ResourceService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin } from "@/core/mixins/resource"
import ReavaliacaoForm from "./ReavaliacaoForm.vue"
import moment from "moment"

export default {
  components: {
    LgFormConstSelect,
    ReavaliacaoForm,
    LgFinderPagePessoa,
  },
  data() {
    return {
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      filtro: {},
      showModalEdit: false,
      optionsFilterTipos: [],
      form: {
        codItemBemPermanente: this.ItemBemPermanente.id,
        situacao: 1,
        codTipoAlteracao: null,
        responsavel: null,
      },
    }
  },
  props: {
    ItemBemPermanente: {
      type: Object,
      required: true
    },
    prefix: {
      Array,
      default: () => [],
    },
  },
  mixins: [ListResourceMixin, ConfirmMixin],
  beforeMount() {
    this.$service = new ResourceService(`/api/reavaliacao`)
    new ResourceService(`/api/reavaliacao`).get(`tipos`).then((response) => {
      this.optionsFilterTipos = [
        { text: "Todos", value: null },
        ...response.data.map((item) => ({
          text: item.descricaoTipoAlteracaoValorItemBemPermanente,
          value: item.codTipoAlteracaoValorItemBemPermanente,
        })),
      ]
    })
  },
  mounted() {
    this.load()
  },
  watch: {
    page() {
      this.load()
    },
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix,]
    },
    title() {
      return this.updatedPrefix.join(" > ")
    },
    tableFields() {
      return [
        { key: "dataDepreciacaoValorizacaoItemBemPermanente", label: "Data",formatter: (data) => moment(data).format("DD/MM/yyyy"), },
        { key: "codPessoaRespAvalDepValItemBemPermanente.nome", tdClass:"pd-1", label: "Responsável" },
        { key: "descricao", tdClass:"pd-1", label: "Tipo Alteração" },
        { key: "observacaoDepreciacaoValorizacaoItemBemPermanente", tdClass:"pd-1", label: "Observação" },
        { key: "valorDepreciacaoValorizacaoItemBemPermanente", tdClass:"pd-1", label: "Valor" },
        { key: "porcentagemDepreciacaoValorizacaoItemBemPermanente", tdClass:"pd-1", label: "%" },
        { key: "editar", label: "", tdClass: "w-1 align-items-center" },
        { key: "situacao", label: "", tdClass: "w-1 align-items-center" },
      ]
    },
    responsavelId() {
      return this.form.responsavel ? this.form.responsavel.id : null
    }
  },
  methods: {
    cancelar() {
      this.showModalEdit = false
      this.id = null
      this.load()
    },
    abrirModalEdit(item) {
      this.id = item.codDepreciacaoValorizacaoItemBemPermanente
      this.showModalEdit = true
    },
    async load() {
      this.busy = true

      await this.$loadResource({
        size: this.perPage,
        page: this.page,
        params: {
          ...this.form,
          codPessoaResp: this.responsavelId
        },
      })
      this.busy = false
    },
    reavaliacaoSelect(item) {
      this.$emit("onDblClickReavaliacao", item)
    },
    async alteraSituacao(item) {
      let response = await this.$confirm(
        "Deseja " +
        (item.situacao === 1 ? "ativar" : "desativar") +
        " a Reavaliação?",
        item.descricao.toUpperCase()
      )
      if (response == true) {
        this.confirmarAlteracaoSituacao(item)
      } else {
        item.situacao = item.situacao === 1 ? 0 : 1
      }
    },

    async confirmarAlteracaoSituacao(item) {
      const { status } = await this.$service.alteraSituacao(item)
      if (status == 200) {
        this.$notify({
          type: "success",
          message: `Registro ${item.situacao ? "Ativado" : "Desativado"
            } com sucesso!`,
        })
      } else {
        this.$notify({
          type: "danger",
          message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
            } o registro!`,
        })
      }
    },
  },
}
</script>
